// config.js

const bizIcon = "https://cdn.chime.me/image/fs/user-info/202259/17/h200_original_57931914-b11b-464b-9c46-7bbf62ee2eb2-png.webp";
const imageOne = "https://media.istockphoto.com/id/1597694844/photo/long-driveway-leading-to-three-car-garage.jpg?s=612x612&w=0&k=20&c=cA-B87tP0rMjB1RwN56Gk7eqWYsFHBMqfaE8RGCenGE=";
const imageTwo = "https://media.istockphoto.com/id/1256343553/photo/new-two-story-home-with-gray-stone-and-white-siding-exterior.jpg?s=612x612&w=0&k=20&c=4ab-I5rvyM16jTL_Obqi4fOnxLDFyBk6JJ8b7q0KAfw=";
const imageThree = "https://media.istockphoto.com/id/1305869265/photo/boulder-city-in-nevada-united-states.jpg?s=612x612&w=0&k=20&c=MlSSBkuTznEGnGQVR3hMvhSA3ElWFVxjVoMtMJzRRRg=";
const imageFour = "https://media.istockphoto.com/id/2022277265/photo/aerial-shot-of-las-vegas-suburb-with-tightly-packed-houses-and-red-tiled-roofs.jpg?s=612x612&w=0&k=20&c=ytFcVh181SFTtR3spO9Sln3-6jUMfiaewl9ioj7yKuU=";
const imageFive = "https://cdn.chime.me/image/fs/user-info/20241126/5/w640_original_3171e3f9-83e4-4555-a9d5-48dff34c100e-png.webp";

export const siteConfig = {
  title: "Alfredo Rubinstein | More Realty",
  metaDescription: "Alfredo Rubinstein | More Realty",
  theme: {
    primaryColor: "blue-600",
    secondaryColor: "gray-900",
    accentColor: "text-blue-600"
  },
  logo: {
    src: bizIcon,
    alt: "Alfredo Rubinstein | More Realty",
  },
  navigation: [
    { name: "Services", sectionId: "services" },
    { name: "About", sectionId: "about" },
    { name: "Location", sectionId: "location" },
  ],
  businessDetails: {
    name: "Alfredo Rubinstein | More Realty",
    headline: "Your Real Estate Matchmaker in Nevada",
    address: "10845 Griffith Peak Dr #02-188, Las Vegas, NV, 89135",
    description: `
          Alfredo Rubinstein, a proud partner of More Realty, is your trusted guide to buying, selling, and investing in Nevada.`,
  },  
  images: {
    business: {
      src: imageOne,
      alt: "Your Trusted Real Estate Expert in Nevada",
      width: 2432,
      height: 1442
    }
  },
  features: [
    {
      description: 
        "Buying or selling a home is a significant decision, and Alfredo Rubinstein is committed to making the process smooth and rewarding. With his expertise, he ensures every step of your real estate journey is handled with care and precision.",
    },
    {
      description: 
        "With in-depth knowledge of Nevada’s neighborhoods and market trends, Alfredo provides personalized advice to help you find the perfect home or achieve the best value for your property.",
    },
    {
      description: 
        "Alfredo's dedication to exceptional service ensures you feel confident, informed, and supported throughout your real estate journey. His personalized approach turns your real estate goals into reality.",
    },
  ],  
  services: {
    sectionTitle: "Communities Served",
    description: 
      "Alfredo Rubinstein | More Realty proudly serves the dynamic neighborhoods of Nevada, including Las Vegas and surrounding areas. He provides tailored real estate services to meet the unique needs of each client. Whether you're searching for a single-family home, a modern condo, or an investment property, Alfredo's in-depth market expertise and personalized approach ensure you find the perfect fit.",
    callouts: [
        {
          name: 'Single Family/Multi-Family Home',
          description: 
            "Discover Nevada's beautiful neighborhoods with spacious single-family and multi-family homes that offer excellent amenities, family-friendly environments, and proximity to top schools.",
          imageSrc: imageTwo,
          imageAlt: 'Charming single-family home in Nevada',
        },
        {
          name: 'Condo/Townhouse',
          description: 
            "Explore modern and low-maintenance living options in Nevada's vibrant communities, ideal for professionals and those seeking convenient lifestyles with top-notch amenities.",
          imageSrc: imageThree,
          imageAlt: 'Contemporary townhouses in Nevada',
        },
        {
          name: 'Investment Property/Lots',
          description: 
            "Looking to grow your portfolio or build from scratch? Alfredo specializes in finding investment properties and prime lots that offer great potential and stunning Nevada views.",
          imageSrc: imageFour,
          imageAlt: 'Scenic investment property in Nevada',
        },
    ],
  },  
  about: {
    sectionTitle: "About",
    description:   "Alfredo Rubinstein brings unmatched expertise in Nevada real estate, offering clients personalized service backed by a strong work ethic and a passion for excellence. As a proud Las Vegas native and Marine Veteran, Alfredo combines attention to detail with a commitment to delivering ideal results. Fluent in Spanish and Italian, he is dedicated to serving a diverse range of clients. Whether you're buying, selling, or investing, Alfredo ensures a seamless and rewarding experience tailored to your unique needs.",
    image: {
      src: imageFive,
      alt: "Alfredo Rubinstein, trusted Nevada real estate expert.",
      width: 1200,
      height: 800
    }
  },
  location: {
    sectionTitle: "Our Location",
    destinationAddress: "10845 Griffith Peak Dr #02-188, Las Vegas, NV, 89135",
    googleMapsEmbedUrl: 
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3089.631764816182!2d-115.33325748476346!3d36.10896097990058!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c8c439b0616c2b%3A0xabcdef123456789!2s10845%20Griffith%20Peak%20Dr%20%2302-188%2C%20Las%20Vegas%2C%20NV%2089135!5e0!3m2!1sen!2sus!4v1710407450828!5m2!1sen!2sus",
    subCategories: [
      { 
        name: 'Apple Maps', 
        url: 'https://maps.apple.com/?address=10845%20Griffith%20Peak%20Dr%20%2302-188,%20Las%20Vegas,%20NV%2089135&ll=36.108961,-115.333257&q=10845%20Griffith%20Peak%20Dr',
      },
      { 
        name: 'Bing Maps', 
        url: 'https://www.bing.com/maps?q=10845+Griffith+Peak+Dr+%2302-188,+Las+Vegas,+NV+89135&FORM=HDRSC6',
      },
      { 
        name: 'Google Earth', 
        url: 'https://earth.google.com/web/search/10845+Griffith+Peak+Dr+%2302-188,+Las+Vegas,+NV+89135/@36.108961,-115.333257,15a,814.57589625d,35y,0h,0t,0r',
      },
      { 
        name: 'Google Maps', 
        url: 'https://www.google.com/maps/place/10845+Griffith+Peak+Dr+%2302-188,+Las+Vegas,+NV+89135/@36.108961,-115.333257,15z',
      }
    ]
  },  
  contact: {
    sectionTitle: "Ready to Find Your Dream Home?",
    description: "Contact Konstance Washington | Deluxe Properties to discuss your real estate goals or schedule a consultation. Whether you’re buying, selling, or investing in the Los Angeles area, Konstance is here to provide expert guidance and personalized support every step of the way.",
    socialLinks: {
      facebook: "https://alfredorubinsteinrealtor.com/",     
      instagram: "https://www.instagram.com/rubinsteinrealestate/",     
      twitter: "https://www.alfredorubinsteinrealtor.com/",     
      linkedin: "https://www.linkedin.com/in/alfredorubinsteinrealtor/",     
      youtube: "https://www.alfredorubinsteinrealtor.com/",     
    },
    contactNumbers: [
      "Mobile: (702) 741-9965",
    ],
    logo: bizIcon,
    emailRecipient: "alfredorubinstein@gmail.com"
  },
  footer: {
    bizSolutionsLogo: "https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg"
  }
};


